// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-dialog .el-dialog__header {\n  border-bottom: none;\n}\n.imgbox {\n  width: 146px;\n  height: 146px;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
